<template>
  <div class="mt-3">
    <!-- <h1 class="font-bold" v-html="$t('pages.leagueResults.heading', { league: league?.name })" /> -->
    <PartialsGames :games="games" />
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league'
})

const league = useLeagueStore()

const { data } = await useFetch(`/api/v1/leagues/${league.slug}/games`, { 
  key: `league-${league.slug}-results`,
  baseURL: useEnv('apiBase'),
  query: {
    untilDate: useDate().add(-1, 'day').format('YYYY-MM-DD'),
  }
})

const games = computed(() => [...data.value?.games]?.reverse())
</script>
